import BackupRecommendationResource from "./backupRecommendation.resource";

const backupRecommendationModule = angular
  .module("app.resources.backupRecommendation", [])
  .service("BackupRecommendation", BackupRecommendationResource);

export default backupRecommendationModule;



// WEBPACK FOOTER //
// ./src/resources/backupRecommendation/backupRecommendation.module.js